import jQuery from 'jquery';
let $ = jQuery;

/**
* class HSN.TabPanel
*
* Encapsulates the functionality of a tab-based card layout providing multiple, clickable tabs that swap bewtween one visible panel of content.
**/
HSN.TabPanel = function (container, tabSelector, externalTriggers, scrollTo) {
    /**
    * new HSN.TabPanel(container, tabSelector)
    * - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the tabs.
    * - tabSelector (String): A CSS selector that finds the clickable elements that trigger tab switches.
    * - externalTriggers (jQuery | HTMLElement | String): A jQuery object, HTML Element(s), or CSS selector that will ultimately resolve to anchor tags that are not tabs, but should trigger the activation of tabs.
    **/

    var scope = this;

    this._container = $(container);
    this._externalTriggers = $(externalTriggers);
    this._tabSelector = tabSelector;
    this._scrollTo = scrollTo;

    this._container.on('click', this._tabSelector, handleTabSelector);
    this._externalTriggers.on('click', handleExternalTriggers);

    function handleTabSelector(e) {
        e.preventDefault();

        scope.ActivateTab(this, false);
    }

    function handleExternalTriggers(e) {
        e.preventDefault();

        var href = $(this).attr('href');//extract trigger href ID
        href = href.substr(href.indexOf('#'));

        var tabs = $(scope._tabSelector).parent();//tabs parent
        var tab = $('[href=\"' + href + '\"]', tabs);//desired tab
        scope.ActivateTab(tab, true);
    }

    function destroy() {
        scope._container.off('click', scope._tabSelector, handleTabSelector);
        scope._externalTriggers.off('click', handleExternalTriggers);
    }

    return {
        destroy: destroy
    };
};

HSN.TabPanel.prototype = {
    _container: null,
    _externalTriggers: null,
    _tabSelector: null,
    _scrollTo: null,

    /**
    * HSN.TabPanel#ActivateTab(id) -> void
    * - selectedTab (jQuery | HTMLElement | String): A jQuery object, HTML Element(s), or CSS selector that will ultimately resolve to anchor element which represents tab
    * - shouldScrollToTab - scroll to
    * Activates the tab with the given id.
    **/
    ActivateTab: function (selectedTab, shouldScrollToTab) {
        $(selectedTab)
            .parent()
            .addClass('active')
            .siblings()
            .removeClass('active');


        var href = $(selectedTab).attr('href');

        if (href.charAt(0) == '#') {
            shouldScrollToTab = true;
        }

        href = href.substr(href.indexOf('#') + 1);

        $('#' + href, this._container)
            .addClass('active')
            .siblings()
            .removeClass('active');

        if (shouldScrollToTab && this._scrollTo) {
            $('html, body').animate({ scrollTop: $(selectedTab).offset().top }, 100); // note: longer animations make the page seem stuck if user scrolls 
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/TabPanel.js